import IconLabel from "./iconLabel"
import './createOptions.css'
const CreateOptions = (props)=>{
    const {title, icon, active, desc, onClick} = props
    return (
        <div onClick={onClick} className="create-options" style={{background: active?'#7978E9':'white'}}>
           <div className="create-options-h">
            <img style={{width: 32}} src={icon} alt=""/>
            <div className="create-options-h-l" style={{color: active?'white':'initial'}}>{title}</div>
            </div>
            <div className="create-options-h-b" style={{color: active?'white':'initial'}}>
           {desc}
            </div>
        </div>
    )
}
export default CreateOptions